<template>
<div>
    <div class="show_box">
      <div class="box_item">
        <p class="title">参与总客户</p>
        <p class="num">{{joinAllCount}}</p>
        <p class="today">今日：{{joinTodayCount}}</p>
      </div>
      <div class="box_item">
        <p class="title">总新增客户</p>
        <p class="num">{{addAllCount}}</p>
        <p class="today">今日：{{addTodayCount}}</p>
      </div>
      <div class="box_item">
        <p class="title">总流失客户</p>
        <p class="num">{{deleteAllCount}}</p>
        <p class="today">今日：{{deleteTodayCount}}</p>
      </div>
      <div class="box_item">
        <p class="title">总获奖客户</p>
        <p class="num">{{winAllCount}}</p>
        <p class="today">今日：{{winTodayCount}}</p>
      </div>
    </div>
</div>
</template>

<script>
import {dataApi} from "@/services/operate/fissionStatistics.js";

export default {
  name: "tabOneSum",
  props:['fissionId'],
  data() {
    return {
      addAllCount: 0,
      addTodayCount: 0,
      deleteAllCount: 0,
      deleteTodayCount: 0,
      joinAllCount: 0,
      joinTodayCount: 0,
      winAllCount: 0,
      winTodayCount: 0,
    }
  },
  components:{
  },
  mounted() {
    dataApi.getBaseALLData(this.fissionId).then((res)=>{
      let resData = res.data;
      this.addAllCount= resData.addAllCount;
      this.addTodayCount= resData.addTodayCount;
      this.deleteAllCount= resData.deleteAllCount;
      this.deleteTodayCount= resData.deleteTodayCount;
      this.joinAllCount= resData.joinAllCount;
      this.joinTodayCount= resData.joinTodayCount;
      this.winAllCount= resData.winAllCount;
      this.winTodayCount= resData.winTodayCount;
    }).catch(error => console.log('查询失败', error))
  }
}
</script>

<style lang="less" scoped>

.show_box{
  margin-bottom: 20px;
  padding: 0 20px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  .box_item{
    width: 16%;
    height: 190px;
    padding: 12px;
    background-color: #D90B18;
    color: #fff;
    border-radius: 10px;
    margin-right: 30px;
    p{
      margin-bottom: 0;
    }
    .title{
      font-size: 22px;
      text-align: center;
      font-weight: 600;
    }
    .num{
      font-size: 52px;
      font-weight: bold;
      text-align: center;
      line-height: 90px;
      margin-bottom: 14px;
    }
    .today{
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }
  }
}

</style>